export default __webpack_public_path__ + "static/media/call-to-action-02-macbook.173c0494.png";